<template>
    <div class="login">
        <navigation-bar Close/>
        <div class="main-content">
<!--            <div class="logo"><img :src="firstStoreIcon.imgUrl"/></div>-->
            <div class="brand-grid" >
                <img src="@/assets/images/star_line.svg">
                <Logo/>
            </div>
            <div class="title">
                <p class="text">台灣享樂遊 使用串門子品牌服務系統</p>
            </div>

            <div class="tab">
                <!--<button class="tablinks selected">設定密碼</button>-->
                <!-- <button class="tablinks selected">請輸入密碼</button> -->
            </div>
            <p>此門號已在本系統註冊，請輸入您設定的密碼，即可登入成為 台灣享樂遊 的會員，享受各項優惠訊息及新體驗。</p>
            <el-form class="textBox" style="margin-top: 20px" :model="form" ref="loginForm">
                <el-form-item>
                    <el-input placeholder="請輸入 6-12 碼英數混合" v-model="form.password" type="password"
                              show-password
                              autocomplete="off"
                              maxlength="12">
                    </el-input>
                </el-form-item>
            </el-form>
            <div class="btn_box">
                <p>
                    <el-button :class="{hasValue: form.password}" @click="regClick" round :disabled="!form.password">
                        下一步
                    </el-button>
                </p>
                <p style="margin-top: 20px">
                    <router-link v-if="false" :to="{ name: 'PhoneVerify'}" class="forget" style="margin-top: 10px">
                        <a>忘記密碼?</a>
                    </router-link>
                </p>
            </div>
            <div class="brand-bottom-grid" v-if="allStoreIconList">
                <store-icon :list="allStoreIconList" :small="true"/>
            </div>
        </div>
        <toast/>
        <register-dialog :value="isShowRegDialog" :name=name :phone=phone :birthday=birthday :gender=gender :mail=mail  :isCancel="true" @result="onRegDialogClose"/>
        <div class="brand">
            <span>LIFE LINK 串門子品牌服務系統</span>
        </div>


        <loading
            :active.sync=isLoading
            :can-cancel="false"
            :is-full-page="true">
        </loading>
    </div>
</template>

<script>
    //import {checkPassword} from "@/util/validators";
    import Toast from "@/components/Toast.vue";
    import * as mutationTypes from '@/store/mutationTypes';
    import {notNull} from "@/util/common";
    import RegisterDialog from '@/views/auth/RegisterDialog.vue';
    import StoreIcon from '@/views/auth/components/StoreIcon';
    import * as constDefine from '@/store/constDefine';
    import Logo from "@/components/Logo";
    import {saveCryptoUserInfo, saveCryptoUserPhone} from "@/util/cryptoLocalStorage";
    export default {
        name: "SecReg",
        components: {Toast, RegisterDialog, StoreIcon , Logo},
        data() {
            return {
                form: {
                    password: '',
                    reconfirm: ''
                },
                tel: this.$route.query.tel,
                firstStoreIconList: this.$route.query.firstStoreIconList,
                allStoreIconList: this.$route.query.firstStoreIconList,
                firstStoreIcon: this.$route.query.firstStoreIcon,
                registeredStoreIconList: this.$route.query.registeredStoreIconList,
                isShowRegDialog: false,
                name:'',
                phone:'',
                birthday:'',
                gender:'',
                mail:'',
                fcmToken: '',
                isLoading:false,
            }
        },
        created() {
            if (this.$store.state.pageSnapshot[this.$route.name]&&!this.$route.params.tel) {
                let object = this.$store.state.pageSnapshot[this.$route.name];
                for (const key in object) {
                    if (Object.hasOwnProperty.call(object, key)) {
                        const element = object[key];
                        this[key] = element;
                    }
                }
            }
            if (!this.tel) {
                this.$router.push({name: 'Login'});
            }
            this.$store.commit("savePageSnapshot",{routeName:this.$route.name,variable:undefined});
        },
        mounted() {

        },
        methods: {
            /** CommDialog 關閉事件 */
            onRegDialogClose : function (result, type, agree) {
                this.isShowRegDialog = false;
                if (result) {
                    if (agree) {
                        this.submit();
                    }
                }
            },
            regClick : function() {
                let self = this;
                return new Promise (function(resolve, reject){
                    self.isLoading = true;
                    self.$http.fetch`GetUserInfo${{
                        'countryCode':'+886',
                        'phone':self.tel,
                        'password':self.form.password,
                    }}
                    ${json => {
                        if (notNull(json.data)&&json.status===true) {
                            self.name = json.data.name;
                            self.phone = json.data.phone;
                            self.birthday = json.data.birthday;
                            self.gender = json.data.gender;
                            self.mail = json.data.mail;
                            self.isShowRegDialog = true;
                            self.isLoading = false;
                            resolve(json.data);
                        }else{
                            self.isLoading = false;
                            reject('失敗, ' + json.message);
                        }
                    }}`;
                }).catch((error)=>{
                    this.$store.commit(mutationTypes.SHOW_TOAST, error);
                });
            },

            /** 按下註冊 */
            submit: function () {

                this.isLoading = true;
                this.register()
                    .then( this.login )
                    .then( this.getUserInfo )
                    .then( (data) => {
                        this.isLoading = false;
                        this.$router.push({name: 'More'});
                        // this.$router.go(-1);
                        // this.$public.showNotify(data.message, data.status, 3000)
                        // this.dialogTitle = "註冊成功";
                        // this.commDialogShow = true;
                    })
                    .catch( (error) => {
                        this.isLoading = false;
                        // this.$store.commit(mutationTypes.SHOW_TOAST, json.message);
                        this.$store.commit(mutationTypes.SHOW_TOAST, error);
                    });
            },

            /** 註冊 */
            register: function () {
                let self = this;
                self.fcmToken = "";
                // 取得本機的token
                if (window.FirebasePlugin) {
                    let FirebasePlugin = window.FirebasePlugin;
                    //取得本機的 fcm token並更新
                    FirebasePlugin.getToken(function (token) {
                        window.localStorage.setItem(constDefine.KEY_FCM_TOKEN, token);
                    });
                }
                return new Promise(function(resolve, reject) {
                    self.$http.fetchWithEncrypt`Register${{
                        'countryCode': '+886',
                        'phone': self.tel,
                        'password': self.form.password,
                        'fcmToken':window.localStorage.getItem(constDefine.KEY_FCM_TOKEN),
                    }}
                    ${json => {

                        if (json.status === true) {
                            //結束
                            resolve();
                        } else {
                            // this.$store.commit(mutationTypes.SHOW_TOAST, json.message);
                            reject('失敗, ' + json.message);
                        }
                    }}`;
                });
            },

            /** 登入 */
            login: function () {
                let self = this;
                return new Promise(function(resolve, reject) {
                    self.$http.fetchWithEncrypt`SignIn${{
                        'countryCode': '+886',
                        'phone': self.tel,
                        'password': self.form.password,
                    }}
                    ${json => {

                        if (json.status === true) {
                            self.$auth.setAdminToken(json.data.token);
                            // localStorage.setItem('phone', self.form.tel);
                            saveCryptoUserPhone(self.form.tel);
                            localStorage.setItem('token', json.data.token);
                            localStorage.setItem('nickName', json.data.nickName);
                            localStorage.setItem('userCode', json.data.userCode);
                            
                            //取得 fcm token
                            self.receiveNotification();
                            //結束
                            resolve();

                        } else {
                            reject('失敗, ' + json.message);
                        }
                    }}`;
                });
            },

            /** 取得個人資訊 */
            getUserInfo: function () {
                let self = this;
                return new Promise(function(resolve, reject) {
                    self.$http.fetchWithAuth`GetUserInfoWithId${{}}
                    ${json => {

                        if (notNull(json.data)) {
                            saveCryptoUserInfo(json.data);
                            //結束
                            resolve(json.data);
                        } else {
                            reject('失敗, ' + json.message);
                        }
                    }}`;
                });
            },

            /** 推播處理 */
            receiveNotification: function () {
                let self = this;
                if (window.FirebasePlugin) {
                    let FirebasePlugin = window.FirebasePlugin;
                    //取得本機的 fcm token並更新
                    FirebasePlugin.getToken(function (token) {
                        window.localStorage.setItem(constDefine.KEY_FCM_TOKEN, token);
                        self.fcmToken = token;
                        //如果已登入才更新 device token
                        if(self.$auth.isAdminLogin()) {
                            self.updateFcmToken();
                        }
                    });
                }
            },
            /** 上傳新的 fcm token */
            updateFcmToken: function () {
                let self = this;

                this.$http.fetchWithAuth`UpdateDeviceToken${{
                    'token': self.fcmToken,
                    'os': self.$http.getOS(),
                }}`;
            },
            goBack: function () {
                this.$router.go(-1)
            }
        },
        beforeRouteLeave: function(to, from, next) {
            if (to.name=='QrCodePrivacy') {
                this.$store.commit("savePageSnapshot",
                    { 
                    routeName:from.name, 
                        variable:{
                            form:this.form,
                            tel:this.tel,
                            isShowRegDialog:this.isShowRegDialog,
                            name:this.name,
                            phone:this.phone,
                            birthday:this.birthday,
                            gender:this.gender,
                            mail:this.mail,
                        },
                    },
                );
            }else{
                this.$store.commit("savePageSnapshot",{routeName:from.name,variable:undefined});
            }
            next();
        },
    }
</script>
<style lang="less" scoped src="../../less/login.less"/>
<style lang="less" scoped >
    .brand-grid {
        width: 100%;
        height: 90px ;
        justify-content: space-around;
        display: flex;
        img {
            width: 85px;
            height: 85px;
        }
    }

    .brand-bottom-grid {
        width: 100%;
        height: 55px ;
        margin-top: 20px;
        overflow-x: auto;
        div {
            display: flex;
        }
    }

    .title {
        width: 100%;
        margin-top: 20px;

        .text {
            width: 100% ;
            text-align: center;
        }
    }

</style>

